module.exports = __webpack_public_path__ + "img/myguard_about_09.833e89ec.png";